document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'cascade:modalcart:afteradditem',
            (event) => {
              // Start Klaviyo add-to-cart tracking
              const cartItem = event.detail.response;
              // Construct Klaviyo event payload
              const klaviyoEventData = {
                "URL": `https://matierebussiere.com${cartItem.url}`,
                "Product Name": cartItem.product_title,
                "ProductID": cartItem.product_id.toString(),
                "VariantID": cartItem.variant_id.toString(),
                "Variant Name": cartItem.variant_title,
                "ImageURL": cartItem.image,
                "Brand": cartItem.vendor,
                "Price": cartItem.presentment_price,
                "CompareAtPrice": cartItem.original_price ? (cartItem.original_price / 100).toFixed(2) : "0.00",
                "$currency": "CAD", // Assuming CAD, adjust if needed
                "Product Type": cartItem.product_type,
                "Variant SKU": cartItem.sku,
                "Quantity": cartItem.quantity || 1,
                "extra": {
                  "standard": {
                    "event_type": "product_added_to_cart"
                  }
                },
                "$value": cartItem.presentment_price
              };
              // Track event in Klaviyo
              klaviyo.track("Added to Cart", klaviyoEventData)
                // .then(() => {
                //   console.log("Klaviyo tracking event succeeded.");
                // })
                .catch((error) => {
                  console.error("Klaviyo tracking event failed:", error);
                });
              // End Klaviyo add-to-cart tracking
               
              // Open modal
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
